import { createPortal } from "react-dom";
import { useTranslations } from "@/lib/static-intl";
import DesktopSearchPopover from "./desktop-search-popover";
import MobileSearchOverlay from "./mobile-search-overlay";
import SearchTriggerForm from "./search-trigger-form";
import { useSearchInputController } from "./use-search-input-controller";

const SearchInput = ({
  mobileOverlayOnly = false,
  autoOpenMobile = false,
  onMobileOverlayClose,
  mobileOverlayVariant = "default",
} = {}) => {
  const t = useTranslations("header");
  const {
    refs,
    searchState,
    viewportState,
    suggestionState,
    searchActions,
    desktopNavigationState,
  } = useSearchInputController({
    mobileOverlayVariant,
    autoOpenMobile,
    onMobileOverlayClose,
  });
  const { searchRef, mobileSearchInputRef, keyRef } = refs;
  const { searchInFocus } = searchState;
  const {
    mobileOverlayOpen,
    shouldPortalMobileOverlay,
    isDesktopViewport,
  } = viewportState;

  const mobileSearchOverlay = mobileOverlayOpen ? (
    <MobileSearchOverlay
      inputRef={mobileSearchInputRef}
      searchState={searchState}
      suggestionState={suggestionState}
      searchActions={searchActions}
      mobileOverlayVariant={mobileOverlayVariant}
    />
  ) : null;

  return (
    <div ref={searchRef} className={mobileOverlayOnly ? "contents" : "relative w-full"}>
      {!mobileOverlayOnly && (
        <SearchTriggerForm
          searchState={searchState}
          searchActions={searchActions}
          desktopNavigationState={desktopNavigationState}
          placeholder={t("search")}
        />
      )}
      {!mobileOverlayOnly && isDesktopViewport && searchInFocus && (
        <DesktopSearchPopover
          id={keyRef.current}
          searchState={searchState}
          suggestionState={suggestionState}
          searchActions={searchActions}
          desktopNavigationState={desktopNavigationState}
        />
      )}
      {mobileSearchOverlay &&
        (shouldPortalMobileOverlay
          ? createPortal(mobileSearchOverlay, document.body)
          : mobileSearchOverlay)}
    </div>
  );
};

export default SearchInput;
